import { format, parseISO } from 'date-fns';

import { decimal } from 'Helpers/currencyFormat';
import { formatFigure, formatToFixedMoneyWithLocale, ZERO_DASH } from 'Helpers/formatService';

// Table figures: whole numbers, locale separators, en dash for zero.
export const figure = (value) => formatFigure(value, formatToFixedMoneyWithLocale);

// Always two decimals ("45.00"); the money formatters drop trailing zeros.
export const rate = (value) => formatFigure(value, (v, precision) => decimal(Number(v), precision), { precision: 2 });

// Tile figures show a real zero rather than a dash.
export const tileFigure = (value, precision = 0) => formatToFixedMoneyWithLocale(Number(value) || 0, precision);

// A pack-day's hours basis from its parts: "2 shifts × 5h · 1 shift × 9,5h", or just "9,5h"
// when every role works one shift of the same length.
export const hoursBasis = (parts) => {
    if (!parts?.length) {
        return ZERO_DASH;
    }

    const hours = (value) => `${tileFigure(value, 1)}h`;

    if (parts.length === 1 && parts[0].shifts === 1) {
        return hours(parts[0].hours);
    }

    return parts
        .map(({ shifts, hours: perShift }) => {
            const count = shifts === 1 ? $t('1 shift') : $t('{{count}} shifts', { count: shifts });

            return `${count} × ${hours(perShift)}`;
        })
        .join(' · ');
};

export const longDate = (date) => format(parseISO(date), 'EEEE d MMMM yyyy');

export const shortDate = (date) => format(parseISO(date), 'd MMM');

export const percent = (share) => `${Math.round((Number(share) || 0) * 100)}%`;
